import { render, staticRenderFns } from "./mobile-sidebar.vue?vue&type=template&id=40c80736&"
import script from "./mobile-sidebar.vue?vue&type=script&lang=js&"
export * from "./mobile-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./mobile-sidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports